/*
 * Copyright 2024 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { defineComponent } from '../../hooks/useDefinition';
import type {
  CardOwnProps,
  CardHeaderOwnProps,
  CardBodyOwnProps,
  CardFooterOwnProps,
} from './types';
import styles from './Card.module.css';

/**
 * Component definition for Card
 * @public
 */
export const CardDefinition = defineComponent<CardOwnProps>()({
  styles,
  classNames: {
    root: 'bui-Card',
    trigger: 'bui-CardTrigger',
  },
  propDefs: {
    children: {},
    className: {},
    onPress: {},
    href: {},
    label: {},
    target: {},
    rel: {},
    download: {},
    style: {},
  },
  utilityProps: ['grow', 'shrink', 'basis'],
});

/**
 * Component definition for CardHeader
 * @public
 */
export const CardHeaderDefinition = defineComponent<CardHeaderOwnProps>()({
  styles,
  classNames: {
    root: 'bui-CardHeader',
  },
  propDefs: {
    children: {},
    className: {},
  },
});

/**
 * Component definition for CardBody
 * @public
 */
export const CardBodyDefinition = defineComponent<CardBodyOwnProps>()({
  styles,
  classNames: {
    root: 'bui-CardBody',
  },
  propDefs: {
    children: {},
    className: {},
  },
});

/**
 * Component definition for CardFooter
 * @public
 */
export const CardFooterDefinition = defineComponent<CardFooterOwnProps>()({
  styles,
  classNames: {
    root: 'bui-CardFooter',
  },
  propDefs: {
    children: {},
    className: {},
  },
});
